import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Logo } from '../../components/Header/Header';
import { useAuthStore } from '../../stores/useAuthStore';

interface Props {
  mode: 'login' | 'register';
}

export default function AuthPage({ mode }: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, register, isLoading, error } = useAuthStore();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [localError, setLocalError] = useState<string | null>(null);

  const redirectTo = (location.state as any)?.from || '/account';

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLocalError(null);

    if (mode === 'register') {
      if (password.length < 8) {
        setLocalError('Пароль должен быть минимум 8 символов');
        return;
      }
      if (password !== password2) {
        setLocalError('Пароли не совпадают');
        return;
      }
    }

    try {
      if (mode === 'login') await login(email, password);
      else await register(email, password);
      navigate(redirectTo);
    } catch {
      /* store error surfaced below */
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-page__backdrop" />

      <div className="auth-page__card">
        <div className="auth-page__logo">
          <Logo />
        </div>

        <h1 className="auth-page__title">
          {mode === 'login' ? 'Вход в аккаунт' : 'Создать аккаунт'}
        </h1>
        <p className="auth-page__subtitle">
          {mode === 'login'
            ? 'Войдите, чтобы продолжить покупку и управлять заказами.'
            : 'Регистрация нужна для подтверждения email и телефона.'}
        </p>

        <form onSubmit={submit} className="auth-page__form">
          <label className="auth-page__field">
            <span>Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              placeholder="your@email.com"
            />
          </label>

          <label className="auth-page__field">
            <span>Пароль</span>
            <input
              type="password"
              required
              minLength={mode === 'register' ? 8 : undefined}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
              placeholder={mode === 'register' ? 'Минимум 8 символов' : ''}
            />
          </label>

          {mode === 'register' && (
            <label className="auth-page__field">
              <span>Повторите пароль</span>
              <input
                type="password"
                required
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                autoComplete="new-password"
              />
            </label>
          )}

          {(localError || error) && (
            <div className="auth-page__error">{localError || error}</div>
          )}

          <button type="submit" className="auth-page__submit" disabled={isLoading}>
            {isLoading ? 'Подождите...' : mode === 'login' ? 'Войти' : 'Создать аккаунт'}
          </button>
        </form>

        <div className="auth-page__switch">
          {mode === 'login' ? (
            <>
              Ещё нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
            </>
          ) : (
            <>
              Уже есть аккаунт? <Link to="/login">Войти</Link>
            </>
          )}
        </div>

        <Link to="/" className="auth-page__back">
          ← На главную
        </Link>
      </div>
    </div>
  );
}
